import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import { msg } from "@omegagrid/localize";
import rp, { helpers } from '@reporting/rp-app-host';
import { File as WikiFile } from '@reporting/rp-types/wiki';

export class FileFormAdapter extends FormAdapter {

	constructor(
		private a: number,
		private file: WikiFile,
		public path: string = null
	) { super() }

	getColumns() {
		return [
			{width: 125},
			{width: null},
		];
	}

	async getControls() {
		let folder: string;
		let name: string;
		if(this.file.filename || this.path) {
			const nameArray = (this.file.filename ? this.file.filename.split('/') : this.path.split('/')) || [];
			name = nameArray.pop();
			folder = nameArray.join('/');
			if (folder) folder += '/';
		}
		const rows = [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('Folder'), for: 'folder'},
			{row: 0, col: 1, type: FormControlType.TextInput, key: 'folder', value: folder ? folder : null},
			{row: 1, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'name'},
			{row: 1, col: 1, type: FormControlType.TextInput, key: 'name', required: true, value: name},
		];
		if (!this.file.idz) { // form for creating new file
			rows.push({row: 2, col: 0, type: FormControlType.Label, value: msg('File'), for: 'file'});
			rows.push({row: 2, col: 1, type: FormControlType.FileInput, value: null, key: 'file', required: true});
		}
		return rows;
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: [
				"save", 
				"close"
			]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		let folder: string = formValues.folder ? formValues.folder as string : '';
		if(folder && folder[folder.length - 1] !== '/') folder += '/';
		this.file.filename = `${folder}${formValues.name}`;
		if (formValues.file) { // upload
			return await this.uploadFile(formValues.file as File, this.file.filename);
		}
		await rp.ms('wiki').post<WikiFile>(`files`, this.file, { accounting: this.a });
		return true;
	}

	async uploadFile(file: File, filename: string):Promise<boolean> {
		const base64Content = await helpers.fileToDataUrl(file);
		const extensionIndex = filename.lastIndexOf('.');
		if (extensionIndex !== -1) {
			filename = filename.substring(0, extensionIndex);
		}
		filename += file.name.substring(file.name.lastIndexOf('.'));
		const wikiFile: WikiFile = {
			filename: filename,
			content: base64Content.split(',')[1],
			size: file.size,
		};
		await rp.ms('wiki').post<WikiFile>(`files`, wikiFile, { accounting: this.a });
		return true;
	}

};
